import { render, staticRenderFns } from "./PlaylistTabPanels.vue?vue&type=template&id=466c61ca&"
import script from "./PlaylistTabPanels.vue?vue&type=script&lang=ts&"
export * from "./PlaylistTabPanels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTabPanels,QTabPanel,QCard,QItem,QItemSection,QItemLabel,QIcon,QBtn,QTooltip,QDialog,QCardSection,QForm,QInput,QPopupProxy,QTime,QToggle,QDate,QCheckbox,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTabPanels,QTabPanel,QCard,QItem,QItemSection,QItemLabel,QIcon,QBtn,QTooltip,QDialog,QCardSection,QForm,QInput,QPopupProxy,QTime,QToggle,QDate,QCheckbox,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
